module.exports = __webpack_public_path__ + "03_bob_yellow.e1cc259a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_bob_yellow.png
// module id = SbZc
// module chunks = 0